import {
  IconBuildingStore,
  IconHistory,
  IconKey,
  IconLayoutDashboard,
  IconPlugConnected,
  IconReceipt2,
  IconShieldX,
  IconUsers,
  IconWebhook,
} from '@tabler/icons-react'
import type { ComponentType } from 'react'

import type { Role } from './apiTypes'

export type NavItem = {
  to: string
  label: string
  icon: ComponentType<{ size?: number; stroke?: number; 'aria-hidden'?: boolean | 'true' }>
  /** Peran yang boleh melihat menu; kosong berarti semua peran. */
  roles?: Role[]
}

/**
 * Menu konsol. Setiap butir punya halaman nyata: tidak ada tautan ke halaman
 * yang belum ada. Menu Pengguna hanya untuk admin, sesuai kontrak Admin API
 * yang menolak seluruh /users untuk viewer.
 */
export const navItems: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: IconLayoutDashboard },
  { to: '/transactions', label: 'Transaksi', icon: IconReceipt2 },
  { to: '/webhooks', label: 'Webhook', icon: IconWebhook },
  { to: '/inbound-rejections', label: 'Notifikasi ditolak', icon: IconShieldX },
  { to: '/clients', label: 'Client', icon: IconPlugConnected },
  { to: '/merchants', label: 'Merchant', icon: IconBuildingStore },
  { to: '/credentials', label: 'Kredensial', icon: IconKey },
  { to: '/users', label: 'Pengguna', icon: IconUsers, roles: ['admin'] },
  { to: '/audit-logs', label: 'Audit log', icon: IconHistory },
  { to: '/security', label: 'Keamanan akun', icon: IconKey },
]

/** Menu yang terlihat untuk sebuah peran. */
export function navItemsForRole(role: Role | null, restricted = false): NavItem[] {
  return navItems.filter((item) => (!item.roles || (role !== null && item.roles.includes(role))) && (!restricted || !['/clients', '/credentials', '/audit-logs'].includes(item.to)))
}

/** Judul halaman dari path, dipakai kepala halaman saat tidak ada judul khusus. */
export function navLabelForPath(pathname: string): string {
  const exact = navItems.find((item) => item.to === pathname)
  if (exact) {
    return exact.label
  }
  const parent = navItems
    .filter((item) => item.to !== '/' && pathname.startsWith(`${item.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0]
  return parent ? parent.label : 'Konsol'
}
